import { classNames } from "primereact/utils";
import { SkeletonItem } from "../skeletons/SkeletonItem";
import styles from "./SectionInfoRow.module.scss";

interface ISectionInfoRow {
  label: string | JSX.Element;
  data?: string | number | JSX.Element;
  isLoading: boolean;
  skekletonWidth?: string | number;
  onClick?: () => void;
}

export const SectionInfoRow = ({
  label,
  data,
  isLoading,
  skekletonWidth,
  onClick,
}: ISectionInfoRow) => {
  return (
    <div
      className={classNames(styles.pair, {
        [styles.pair_clickable]: !!onClick,
      })}
      onClick={onClick}
    >
      <p className={styles.pair_left}>
        {typeof label === "string" ? `${label}:` : label}
      </p>
      <SkeletonItem
        className={styles.pair_right}
        value={<p>{data}</p>}
        isLoading={isLoading}
        width={skekletonWidth}
      />
    </div>
  );
};
